<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'MainPage',
};
</script>

<style scoped>

</style>
